import * as React from 'react';

import ErrorBoundary from '@components/ErrorBoundary';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { getGiftCampaigns } from '@lib/gift';

import messages from '../../../messages';
import { useProductDetailContext } from '../../../ProductDetailContext';
import { GiftBase } from '../ProductGifts/GiftBase/GiftBase';

export const Gift = () => {
  const { product, currentVariant } = useProductDetailContext();
  const { experiment_pd_loyalty_gift } = useFeatureFlags();
  const { giftCampaigns } = getGiftCampaigns({
    product,
    variant: currentVariant,
    hideLoyaltyGifts: !experiment_pd_loyalty_gift,
  });

  if (giftCampaigns.length === 0) {
    return null;
  }

  const titleMessage =
    giftCampaigns.length > 1 ? messages.giftsForYou : messages.giftForYou;

  const shouldShowPickUpInformation =
    currentVariant.availability.availablePickUpStores > 0;

  return (
    <ErrorBoundary>
      <GiftBase
        containerId="pdGift"
        titleMessage={titleMessage}
        imageMessage={messages.giftForYou}
        campaigns={giftCampaigns}
        shouldShowPickUpInformation={shouldShowPickUpInformation}
      />
    </ErrorBoundary>
  );
};
